import React, { useState, useEffect } from 'react';

const ReporteBloqueIndividual = (p) => {
    const reporte = p.reporte ?? {};
    const bloque_nombre = reporte?.bloque_nombre ?? "Sin nombre";
    const reportes = Object.keys(reporte).filter((key) => key !== 'bloque_nombre');
    const len = reportes.length;
    const [selected, setselected] = useState('PLANTAS');

    const siguienteReporte = () => {
        let index = reportes.indexOf(selected) + 1;
        if (index >= len) index = 0;
        setselected(reportes[index]);
    }

    return (
        <div className='w-100 p-1 round-s m-0 mb-3 border gradient-soft-greyBlue'>
            <div className='row justify-content-evenly w-100 m-0 p-0'>

                <div className='w-100 m-0 p-0'>
                    <div className='row justify-content-start m-0 p-0'>
                        <div className='text-bold w-100 round-top-s pointer bg-white3 multishadow-xs' onClick={siguienteReporte}>
                            {bloque_nombre}
                            <span className='text-xs text-blue4 text-bold ms-2'>REPORTE POR {selected}</span>
                        </div>

                    </div>
                </div>
                {
                    reporte[selected] && reporte[selected].reportes.map((rep, i) =>
                        <div className='bw-250 border-bottom mt-2' style={{ lineHeight: '1' }} key={`reporte-${i}`}>
                            <div className='w-100 text-xs text-blue3'>{rep.nombre}</div>
                            <div className='w-100 text-bold'>{rep.value.toLocaleString('en-US')}<span className='text-xs text-bold opacity-60 ms-1'>{rep.tipo}</span></div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default ReporteBloqueIndividual;